import { Box, Typography, useTheme } from "@mui/material"
import { ReactElement } from "react"

/** Fallback text for when zero search results are returned */
const ZeroPendingUsersMsg = (): ReactElement => {
    const theme = useTheme()
    return (
        <Typography variant="h6" component="div">
            You currently have{" "}
            <Box color={theme.palette.primary.main} display="inline">
                no pending users
            </Box>{" "}
        </Typography>
    )
}

export default ZeroPendingUsersMsg
